
const PRODUCTS = {
    LOCAL: 'LOCAL',
    TEST: 'TEST',
    ONLINE: 'ONLINE'
};

//产品环境
const product = PRODUCTS.ONLINE;
/**
 * 资源服务地址
 */
export const RESOURCE_SERVICE = {
    LOCAL: {
        FILE: 'http://127.0.0.1:7012/resource/file',
        IMAGE: 'http://127.0.0.1:7012/resource/image'
    },
    TEST: {
        FILE: 'http://172.16.40.27:7090/resource/file',
        IMAGE: 'http://172.16.40.27:7090/resource/image'
    },
    ONLINE: {
        FILE: window._fileUrl,
        IMAGE: window._imgUrl
    }
};

export function getResource() {
    console.log(RESOURCE_SERVICE[product]);
    
    return RESOURCE_SERVICE[product];
};

//文件上传类型限制
export const uploadImgType = '.jpg,.jpeg,.png';
export const uploadFileType = '.doc,.docx,.pdf';
export const uploadVideoType = 'mp4';


/**
 * 代办任务来源
 */
export const TaskOrigin = {
    redare_archives: '档案管理平台',
    redare_bidding: '招投标项目管理平台',
    project_management: '项目管理系统',
    redare_hr: '人力资源系统',
    redare_invoice: '开票系统',
    fssc: '财务共享平台'
};
